export type CursorPackEventKind = "install"

// Fire-and-forget usage beacon — tracking must never disturb the user flow, so failures are swallowed.
export const trackCursorPackEvent = (url: string | undefined, kind: CursorPackEventKind) => {
  if (!url) return

  const token = document.querySelector<HTMLMetaElement>("meta[name='csrf-token']")?.content
  void fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { "X-CSRF-Token": token } : {}),
    },
    body: JSON.stringify({ kind }),
    keepalive: true,
  }).catch(() => {})
}
